import React, { useCallback, useState,useRef } from "react";
import { onCheckBoxClick } from "../../redux/actions/receipt";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import { GridLayout } from "../../common/GridLayout";
import { Localization } from "../../common/Localization";
import HistoryTransactionButtons from "./HistoryTransactionButtons";
import { handleDataGridExport } from "../../common/Utils";
import {
  Column,
  DataGrid,
  Editing,
  GroupPanel,
  Scrolling,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Toolbar,
  Item,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import "jspdf-autotable";
import "./wmmodulestyle.css";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";

const HistoryTransactionList = (props) => {
const dataGrid = useRef(null);
  const [currentLayout, setCurrentLayout] = useState("Default");
  const SearchPanelAccordionStatus = props.SearchPanelAccordionStatus;
  var accessToken = props.oidc.user.access_token;
  const dataBase =
    props.ReceiptReducer.wmTransactionDatabase !== ""
      ? props.ReceiptReducer.wmTransactionDatabase
      : "";
  const dispatch = useDispatch();
  const onSelectionChanged = ({ selectedRowsData }) => {
    const data = selectedRowsData[0];
    if (!props?.status) dispatch(onCheckBoxClick(data));
    if (selectedRowsData.length === 1) {
      props.transactionCallback(data);
    } else {
      props.transactionCallbackOnUnCheck(0);
    }
  };

  const handelClickManiFest = () => {
    props.handleClickOpenDialogue();
  };
  const handelClickAppointment = () => {
    props.handleClickOpenTransAppointmentDialogue();
  };
  const handelClickScheduling = () => {
    props.handleClickOpenTransSchedulingDialogue();
  };
   

  const allowedPageSizes = [10, 20, 100, 300];
  const gridKey = "084f195f-41c1-48a1-8286-2af30dd7a894";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

  return (
    <div>
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        ref={dataGrid}
        allowColumnReordering={true}
        allowColumnResizing={true}
        dataSource={props.data}
        showBorders={true}
        className={SearchPanelAccordionStatus ? "GridHeightAccordianOpen-tabs" : "GridHeightAccordianClose-tabs"}
        hoverStateEnabled={true}
        onSelectionChanged={(e) => onSelectionChanged(e)}
        searchExpr="status"
        remoteOperations={true}
        searchEnabled={true}
      >
        <ColumnChooser
          enabled={true}
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <ColumnHeaderFilter />
        <Export enabled={true} allowExportSelectedData={true} />
        <Selection mode="multiple" />
        <Sorting visible={true} mode="multiple" />
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <HeaderFilter enabled={true} visible={false} />
        <GroupPanel visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Scrolling rowRenderingMode="virtual" />
        {/* <Editing mode="cell" allowUpdating={true} /> */}
        {/* <Column dataField="rowid" caption="Row Id"></Column> */}
        <Column dataField="transactionnumber" caption="Transaction #"></Column>
        <Column
          dataField="transactiondate"
          dataType="date"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.TRANSACTIONDATE', 'Trans Date')}
        ></Column>
        <Column
          dataField="actualreceivedshippeddatetime"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.ACTUALRECEIVEDSHIPPEDDATETIME', 'Recv/Ship Dt')}
          dataType="date"
          visible={false}
          format="MM/dd/yyyy hh:mm:ss aa"
        ></Column>
        <Column dataField="shipper" caption={Localization.formatMessage('WMTRANSACTIONHEADER.R_SHIPPER', 'Shipper ID')}></Column>
        <Column dataField="status" caption={Localization.formatMessage('WMTRANSACTIONHEADER.STATUS', 'Status')}></Column>
        <Column dataField="stage" caption={Localization.formatMessage('WMTRANSACTIONHEADER.STAGE', 'Stage')}></Column>
        <Column dataField="shipperbolnumber" caption={Localization.formatMessage('WMTRANSACTIONHEADER.SHIPPERBOLNUMBER', 'Shipper BOL #')}></Column>
        <Column dataField="reference" caption={Localization.formatMessage('WMTRANSACTIONHEADER.REFERENCE', 'P.O. No')}></Column>
        <Column
          dataField="shipperName"
          caption="Shipper Name"
          visible={false}
        ></Column>
        <Column dataField="pallets" caption="Pallets" visible={false}></Column>
        <Column dataField="comment" caption={Localization.formatMessage('WMTRANSACTIONHEADER.COMMENT', 'Comment')} visible={false}></Column>
        <Column
          dataField="userdefinedcode1"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_1', 'Code 1')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode2"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_2', 'Code 2')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode3"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_3', 'Code 3')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode4"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_4', 'Code 4')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode5"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_5', 'Code 5')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode6"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_6', 'Code 6')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode7"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_7', 'Code 7')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode8"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_8', 'Code 8')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode9"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_9', 'Code 9')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode10"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_10', 'Code 10')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference1"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_1', 'Reference 1')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference2"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_2', 'Reference 2')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference3"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_3', 'Reference 3')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference4"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_4', 'Reference 4')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference5"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_5', 'Reference 5')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference6"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_6', 'Reference 6')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference7"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_7', 'Reference 7')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference8"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_8', 'Reference 8')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference9"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_9', 'Reference 9')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference10"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_10', 'Reference 10')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate1"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_1', 'Date 1')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate2"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_2', 'Date 2')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate3"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_3', 'Date 3')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate4"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_4', 'Date 4')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate5"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_5', 'Date 5')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate6"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_6', 'Date 6')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate7"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_7', 'Date 7')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate8"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_8', 'Date 8')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate9"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_9', 'Date 9')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate10"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_10', 'Date 10')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcomment"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCOMMENT', 'User Defined Comment')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity1"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_1', 'Quantity 1')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity2"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_2', 'Quantity 2')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity3"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_3', 'Quantity 3')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity4"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_4', 'Quantity 4')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity5"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_5', 'Quantity 5')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity6"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_6', 'Quantity 6')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity7"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_7', 'Quantity 7')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity8"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_8', 'Quantity 8')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity9"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_9', 'Quantity 9')}
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity10"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_10', 'Quantity 10')}
          visible={false}
        ></Column>
        <Column
          dataField="plannedreceivedshippeddatetime"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.PLANNEDRECEIVEDSHIPPEDDATETIME', 'Planned Received Shipped D/T')}
          dataType="date"
          visible={false}
          format="MM/dd/yyyy hh:mm:ss aa"
        ></Column>
        <Column
          dataField="container"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.CONTAINER', 'Container #')}
          visible={false}
        ></Column>
        <Column
          dataField="equipmentinterchangereport"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.EQUIPMENTINTERCHANGEREPORT', 'Equip Interchange Report')}
          visible={false}
        ></Column>
        <Column
          dataField="carrier"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.R_CARRIER', 'Carrier #')}
          visible={false}
        ></Column>
        <Column
          dataField="transportCarrier"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.R_TRANSPORTCARRIER', 'Transport Carrier')}
          visible={false}
        ></Column>
        <Column
          dataField="totalNetWeight"
          caption="Total Net Wt"
          visible={false}
        ></Column>
        <Column
          dataField="totalGrossWeight"
          caption="Total Gross Wt"
          visible={false}
        ></Column>
        <Column
          dataField="consigneeName"
          caption="Consignee Name"
          visible={false}
        ></Column>
        <Column
          dataField="carrierName"
          caption="Carrier Name"
          visible={false}
        ></Column>
        <Column
          dataField="transportCarrierName"
          caption="Trans Carrier Name"
          visible={false}
        ></Column>
        <Column
          dataField="transactiongroup"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.TRANSACTIONGROUP', 'Transaction Group')}
          visible={false}
        ></Column>
        <Column
          dataField="freightchargetype"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.FREIGHTCHARGETYPE', 'Freight Charge Type')}
          visible={false}
        ></Column>
        <Column
          dataField="totalQuantityOrder"
          caption="Total Order"
          visible={false}
        ></Column>
        <Column
          dataField="totalQuantityActual"
          caption="Total Actual"
          visible={false}
        ></Column>
        <Column
          dataField="customer"
          caption={Localization.formatMessage('WMTRANSACTIONHEADER.R_CUSTOMER', 'Customer')}
          visible={false}
        ></Column>
        <Column
          dataField="consigneeAddress1"
          caption="Consignee Addr1"
          visible={false}
        ></Column>
        <Column
          dataField="consigneeAddress2"
          caption="Consignee Addr2"
          visible={false}
        ></Column>
        <Column
          dataField="consigneeZip"
          caption="Consignee Zip"
          visible={false}
        ></Column>
        <Column
          dataField="consigneeState"
          caption="Consignee State"
          visible={false}
        ></Column>
        <Column
          dataField="consigneeAddressMemo"
          caption="Consignee Addr Memo"
          visible={false}
        ></Column>
        <Column
          dataField="shipperAddress1"
          caption="Shipper Addr1"
          visible={false}
        ></Column>
        <Column
          dataField="shipperAddress2"
          caption="Shipper Addr2"
          visible={false}
        ></Column>
        <Column
          dataField="shipperZip"
          caption="Shipper Zip"
          visible={false}
        ></Column>
        <Column
          dataField="shipperState"
          caption="Shipper State"
          visible={false}
        ></Column>
        <Column
          dataField="shipperAddressMemo"
          caption="Shipper Addr Memo"
          visible={false}
        ></Column>

        <Toolbar>
          <Item location="before">
          <HistoryTransactionButtons
              disable={props.disable}
              deletedTransactionNumber={props.deletedTransactionNumber}
              rowid={props.rowid}
              permission={props.permission}
              loadTransactions={props.loadTransactions}
              status={"Z"}
            />
          </Item>
          <Item location="before">
            {
              <div>
                <Button
                  disabled={(props.disable)}
                  className="gridTopButton"
                  text={"Manifest"}
                  onClick={handelClickManiFest}
                  type="default" />
              </div>
            }
          </Item>
          <Item location="before">
            {
              <div>
                <Button
                  disabled={(props.disable)}
                  className="gridTopButton"
                  text={"Appointment"}
                  onClick={handelClickAppointment}
                  type="default" />
              </div>
            }
          </Item>
          <Item location="before">
            {
              <div>
                <Button
                  disabled={(props.disable)}
                  className="gridTopButton"
                  text={"Scheduling"}
                  onClick={handelClickScheduling}
                  type="default" />
              </div>
            }
          </Item>
          <Item location="after">
            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
        </Toolbar>
      </DataGrid>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc,
    ReceiptReducer: state.ReceiptReducer,
  };
}
export default connect(mapStateToProps)(HistoryTransactionList);
